import { render, staticRenderFns } from "./10-raisons-de-choisir-wordpress-pour-votre-site-web.vue?vue&type=template&id=ade086e4&"
import script from "./10-raisons-de-choisir-wordpress-pour-votre-site-web.vue?vue&type=script&lang=js&"
export * from "./10-raisons-de-choisir-wordpress-pour-votre-site-web.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports